module.exports = __webpack_public_path__ + "static/media/Nguyen_Nang_Hung.48e283cb.jpg";